import React, {Component, Fragment} from 'react'
import {Row, Col, Button} from 'reactstrap'
import autobind from 'auto-bind'

import Modal from './modals/edit'

export default class extends Component {
    constructor(props) {
        super(props)
        autobind(this)

        this.state = {
            modalOpen: false,
        }
    }

    toggleModal() {
        this.setState({
            modalOpen: !this.state.modalOpen,
        })
    }

    render() {
        return (
            <Fragment>
                <Row>
                    <Col>
                        <h1 className="mb-0">Kanban Settings</h1>
                        <h4 className="text-muted">
                            Click below to configure kanban display settings for
                            this data model.
                        </h4>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <Button onClick={this.toggleModal}>
                            Update Kanban Settings
                        </Button>
                        <hr />
                    </Col>
                </Row>
                {this.state.modalOpen ? (
                    <Modal
                        toggle={this.toggleModal}
                        open={this.state.modalOpen}
                        {...this.props}
                    />
                ) : null}
            </Fragment>
        )
    }
}
